export default __webpack_public_path__ + "static/media/bg04.b71d4c80.png";